import {Component, Prop, h, State, Element, Event, type EventEmitter, Listen, Watch, getAssetPath} from '@stencil/core';
import {mapWidgetData, mapToCreation} from './utils/map-widget-data';
import {widgetStatistics} from './offsites-widget-statistics';
import type {AnalyticsGenericEvent} from '../../../utils/analytics/AnalyticsGenericEvent';
import {widgetData} from './assets/offsites-assets/config.json';

@Component({
  tag: 'uiaas-offsites-widget',
  styleUrl: 'offsites-widget.scss',
  shadow: true,
  assetsDirs: ['assets/offsites-assets']
})
export class UiaasOffsitesWidget {

  private offsiteWidgetData = widgetData;

    /**
     * Get related product for banners
     */
    @State() relatedProduct: string;

    @Prop({mutable:true}) relatedProductName?: string;

    /**
     * Country code, used to retrieve data from config file
     */
    @Prop() readonly country: string;

    /**
     * Language name, used to retrieve data from config file
     */
    @Prop() readonly language: string;

    /**
     * Search term, used to retrieve data from config file
     */
    @Prop({ mutable: true, reflect: true }) term: string;

    /**
     * Brand name, used to retrieve data from config file
     */
     @Prop() readonly brand: string = 'se';

    /**
     * Name of te TAB from UIAAS used for widget stats
     */
    @Prop({mutable:true}) tabName: string = '';

    /**
     * Currently selected Item
     */
    @State() currentTab;

    @Prop() readonly isDashboardView: boolean = false;
    @Prop() readonly analyticsTabName?: string;
    private searchStartedEv: void;

    @Element()
      el: HTMLElement;

    @Event({
      eventName: 'search:widgetEvent',
      composed: true,
      cancelable: true,
      bubbles: true,
    })
      statisticsEventEmitter: EventEmitter<AnalyticsGenericEvent>;

    connectedCallback() {
        if (!this.tabName) {
          const closestTabEl = this.el.closest('uiaas-search-tab,dashboard-tab-view-v2');
          if (closestTabEl) {
            this.tabName = closestTabEl['tabName'];
          }
        }
        this.searchStartedEv = this.el
          .closest('uiaas-search-tab')
          ?.addEventListener('search:started', (e) => {
              this.term = e.detail.term;
          });
    }

    @Listen('search:tabClick', { target: 'window' })
    handleCurrentTab(event) {
        this.currentTab = event.detail.tabName; // Get second part of event tab name
    }

    @Listen('search:SearchResultsRelatedProduct', { target: 'window' })
    handleRelatedProduct(event) {
        // Check if relatedProductName exist, if not, load it from event
        if (!this.relatedProductName) this.relatedProductName = event.detail.relatedProduct;
    }
    private emitSearchStatisticsEvent = (e: AnalyticsGenericEvent) => {
        this.statisticsEventEmitter.emit(
          e
        );
    };
  
    disconnectedCallback() {
        this.searchStartedEv = this.el
          .closest('uiaas-search-tab')
          ?.removeEventListener('search:started', (e) => {
              this.term = e.detail.term;
          });
    }

    render() {
        const data = mapWidgetData(this.offsiteWidgetData, this.country, this.language, this.term , this.brand, this.tabName, this.relatedProductName);
        const tab = this.analyticsTabName ?? this.tabName;
        const currentTabName = this.currentTab ?? document.querySelector('uiaas-search-tab,dashboard-tab-view-v2')?.['tabName'];

        if (Object.keys(data).length && (currentTabName === this.tabName) ) {
          return (
            <div class={ this.isDashboardView
              ? `offsites-widget ${data.widgetType}`
              : `offsites-widget ${data.widgetType} offsites-widget__offset`}>
              <a class="offsites-widget__url" target="_blank" href={data.titleUrl} onMouseDown={(e) => {
                  this.emitSearchStatisticsEvent(widgetStatistics.sendUserRedirectionStatisticsEvent('background', data.widgetType, data.widgetName, tab, e.button == 0 ? 'left' : 'right', data.titleUrl));
              }
              }
              onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.emitSearchStatisticsEvent(widgetStatistics.sendUserRedirectionStatisticsEvent('background', data.widgetType, data.widgetName, tab, e.key, data.titleUrl));
                  }
              }}
              >
                {mapToCreation(data, this.emitSearchStatisticsEvent, this.tabName, this.analyticsTabName, this.isDashboardView)}
              </a>
            </div>);
        }
    }
}
